import React from 'react';
import {LinkContainer} from 'react-router-bootstrap'
import {Button} from 'react-bootstrap';
import Layout from '../common/Layout';
import Logo from '../common/Logo';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';

import {useBreakpoint} from '../util/handleBreakpoints';

import {useTranslation} from 'react-i18next';

import ContentBackgroundArt from '../common/ContentBackgroundArt';

const Home = () => {
    const {t} = useTranslation();
    const breakpoints = useBreakpoint();

    return <Layout navSecondaryShow={true}
        style={
            {
            }
        }
    >
        {/* <Helmet><title>{t('Home.page-head-title')}</title></Helmet> */}
        <style>
            {`
                .home__container {
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    flex-grow: 1;
                    flex-shrink: 0;
                    position: relative;
                    background: no-repeat bottom right url('${process.env.PUBLIC_URL}/background-home-cover.jpg');
                    min-height: calc(100vh - 44px);
                    max-height: 1920px;
                    background-color: #fff;
                    background-size: cover;
                    padding: 1rem 1rem;
                    padding-bottom: 6rem;
                }

                .home__container:after {
                    content: '';
                    position: absolute;
                    display: block;
                    height: 4vh;
                    left: 0;
                    bottom: 0;
                    right: 0;
                }

                .home__container:before {
                    content: '';
                    position: absolute;
                    display: block;
                    background: linear-gradient(180deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
                    height: 30vh;
                    left: 0;
                    top: 0;
                    right: 0;
                }
                
                .home__backdrop {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }

                .home__navigation-options {
                    position: relative;
                    z-index: 3;
                    flex-basis: 40rem;
                    flex-grow: 1;
                    flex-shrink: 1;
                    margin-bottom: auto;
                }
                
                .home__navigation-options__container {
                    background-color: rgba(255,255,255,0.955);
                    border: 3px solid #ececec;
                    border-radius: 1.75rem;
                    overflow: hidden;
                    box-shadow: .100rem .100rem .75rem rgba(0,0,0,0.085);
                    padding: 3rem 2rem 1.5rem 2rem;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                }
                
                @media(min-width: 850px) {
                    .home__navigation-options__container {
                        max-width: 600px;
                        margin: 3rem 13.5vw auto 13.5vw;
                    }
                }
                
                @media(max-height: 850px) and (min-width: 850px) {
                    .home__navigation-options__container {
                        max-width: 1000px;
                        margin: 12vh 9vw auto 9vw;
                    }
                }
                @media(max-height: 770px) and (min-width: 850px) {
                    .home__navigation-options__container {
                        max-width: 1000px;
                        margin: 10vh 10vw auto 10vw;
                    }
                }

                @media(max-width: 849px) {
                    .home__navigation-options__container {
                        margin: 0;
                    }
                }

                @media(max-width: 730px) {
                    .home__navigation-options__container {
                        padding: 2.5rem 0.5rem 0.5rem 0.5rem;
                    }
                }
                
                .home__navigation-options__greeting {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-wrap: wrap;
                    flex-basis: max-content;
                    margin-bottom: 1rem;
                }
                
                .home__navigation-options__greeting__logo {
                    margin: 0 1rem;
                    max-width: 6.65rem;
                    max-height: 6.65rem;
                    width: 100%;
                    height: 100%;
                    flex-grow: 1;
                    flex-shrink: 0;
                    flex-basis: 10rem;
                    background: #F37221;
                    padding: 0.8rem;
                    border-radius: 2rem;
                    box-shadow: 0.5rem 0.5rem 1rem rgba(0,0,0,0.1);
                }

                .home__navigation-options__greeting__greeting-text {
                    flex-grow: 1;
                    flex-shrink: 1;
                    text-align: center;
                }

                .home__navigation-options__greeting__greeting-text h3 {
                    line-height: 1.3;
                    font-size: 2.25rem;
                    font-weight: 400;
                    margin: 1.5rem;
                    margin-bottom: 0.5rem;
                    letter-spacing: -0.015em;
                }

                @media(max-width: 630px) {
                    .home__navigation-options__greeting__greeting-text h3 {
                        font-size: 2rem;
                        margin-left: 0.5rem;
                        margin-right: 0.5rem;
                    }
                }


                .home__navigation-options__options {
                    display: flex;
                    flex-wrap: wrap;
                    flex-grow: 1;
                    width: 100%;
                }

                .home__navigation-options__options__option {
                    flex-grow: 1;
                    flex-shrink: 1;
                    flex-basis: 26rem;
                    padding: 2rem 1rem;
                    padding-bottom: 1.5rem;
                    padding-top: 1.5rem;
                    display: flex;
                    flex-direction: column;
                }
                .home__navigation-options__options__option p {
                    line-height: 1.9;
                }

                .home__navigation-options .logomark__fill {
                    fill: #fff;
                }
            `}
        </style>
        <div
            className="home__container"
            style={
                {

                }
            }
        >
            <ContentBackgroundArt fill="rgba(255,255,255,0.2)" />
            <div
                className="home__navigation-options"
            >
                <div
                    className="home__navigation-options__container"
                >
                    <div
                        className="home__navigation-options__greeting"
                    >
                        <div
                            className="home__navigation-options__greeting__logo"
                        >
                            <Logo />
                        </div>
                        <div
                            className="home__navigation-options__greeting__greeting-text"
                        >
                            <h3>
                                {t('Home.welcome.p1')}
                                <nobr><strong>{t('Home.welcome.p2')}</strong></nobr>
                                {t('Home.welcome.p3')}
                            </h3>
                        </div>
                    </div>
                    <div
                        className="home__navigation-options__options"
                    >
                        <div
                            className="home__navigation-options__options__option"
                        >
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        marginTop: 'auto'
                                    }
                                }
                            >
                                <p
                                    style={
                                        {
                                            textAlign: 'center',
                                        }
                                    }
                                >
                                    {t('Home.explanation-providers-search')}
                                </p>
                            </div>
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        marginTop: 'auto',
                                        paddingTop: '0.5rem',
                                        justifyContent: 'center',
                                    }
                                }
                            >
                                <LinkContainer to='/providers-search' style={{borderRadius: '5rem'}}>
                                    <Button size={breakpoints.sm ? "md" : "lg"}
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                        <span className="ml-3">{t('Home.go-to-providers-search')}</span></Button>
                                </LinkContainer>
                            </div>
                        </div>
                        <div
                            className="home__navigation-options__options__option"
                        >
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        marginTop: 'auto'
                                    }
                                }
                            >
                                <p
                                    style={
                                        {
                                            textAlign: 'center',
                                        }
                                    }
                                >
                                    {t('Home.explanation-provider-application')}
                                </p>
                            </div>
                            <div
                                style={
                                    {
                                        display: 'flex',
                                        marginTop: 'auto',
                                        paddingTop: '0.5rem',
                                        justifyContent: 'center',
                                    }
                                }
                            >
                                <LinkContainer to='/provider-application' style={{borderRadius: '5rem'}}>
                                    <Button className="" variant="dark" size={breakpoints.sm ? "md" : "lg"}
                                    >
                                        <span>{t('Home.go-to-provider-application')}</span></Button>
                                </LinkContainer>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="home__backdrop"></div>
        </div>
    </Layout >
}

export default Home;
